import { useTranslation } from 'react-i18next'

import * as Styles from './styles'

const GiftReturnToggle = ({ isGiftReturn, onReturnToRegularOrder, allowsGiftReturns, onReturnToGiftReturn }) => {
  const { t } = useTranslation()

  if (isGiftReturn) {
    return (
      <Styles.ToggleButton type="button" variant="text" fullWidth onClick={onReturnToRegularOrder}>
        {t('Devolver un pedido normal')}
      </Styles.ToggleButton>
    )
  }

  if (allowsGiftReturns) {
    return (
      <Styles.ToggleButton type="button" variant="text" fullWidth onClick={onReturnToGiftReturn}>
        {t('Devolver regalo')}
      </Styles.ToggleButton>
    )
  }

  return null
}

export default GiftReturnToggle
